import React from 'react';
import { CodeSnippetApiDto } from "../common/dto/CodeSnippetApiDto";
import HighlightedCode from "../comp/HighlightedCode";

type Props = {
    snippet: CodeSnippetApiDto
}

function* range(from: number, to: number): Generator {
    for (let i = from; i < to; i++) {
        yield i;
    }
}

const CodeSnippet = (props: Props) => {

    const lineNumbers: string[] = Array.from(
        range(props.snippet.lineNumberStart, props.snippet.lineNumberEnd + 1)) as string[];

    const type = props.snippet.isError ? 'viga' : 'kommentaar';

    const style = (snippet: CodeSnippetApiDto, ln) => {
        if (snippet.lineNumber !== ln) {
            return "";
        }

        return snippet.isError
            ? 'source-row-number-link-error'
            : 'source-row-number-link-message';
    };

    return (
        <div className="review-code-block mt-3">
            Failis { props.snippet.fileName } real {props.snippet.lineNumber}
            &nbsp;on { type }: { props.snippet.commentText }

            <div className="source-container">
                <div className="source-row-numbers">
                    { lineNumbers.map(ln => <div
                        className={ style(props.snippet, ln) }
                        key={ln}>{ln}<br /></div>) }
                </div>
                <div>
                    <HighlightedCode fileContents={ props.snippet.code }
                                     fileName={ props.snippet.fileName } />
                </div>
            </div>

            <hr />

        </div>
        );
};

export default CodeSnippet;
